export default __webpack_public_path__ + "static/media/BMG-Logo-DEF-02.2fac8e4d.svg";